import { render, staticRenderFns } from "./About_test.vue?vue&type=template&id=62ef3277&scoped=true&"
import script from "./About_test.vue?vue&type=script&lang=js&"
export * from "./About_test.vue?vue&type=script&lang=js&"
import style0 from "./About_test.vue?vue&type=style&index=0&id=62ef3277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef3277",
  null
  
)

export default component.exports